import { useCallback, useEffect, useState } from "react";
import { Alert, AlertColor } from "@mui/material";
import localisations from "domains/allocations/localisation";
import { useQuerySnapshot } from "domains/allocations/services/use-allocation-api";
import { QuerySnapshotOptions } from "domains/allocations/services/allocation-service";
import { ManagedProductStatus } from "domains/allocations/components/managed-product-status";
import allocationLocalisations from "domains/allocations/localisation";

interface IProductWithInPartitionStatusProps {
    productId: number | null;
    partitionId: string;
    forceRefresh: boolean;
    onLoaded?: (status: boolean) => void;
    handleTransferProductStatus : (status: boolean) => void;
}

const InnerProductWithInPartitionStatus = (props: IProductWithInPartitionStatusProps) => {
    let options = { partitionId: props.partitionId } as QuerySnapshotOptions;
    const { loading, data, error, refresh } = useQuerySnapshot(options);
    const { forceRefresh, onLoaded } = props;
    const [managedWithInPartition, SetManagedWithInPartition] = useState<null | boolean>(null);
    const [productRefresh, setProductRefresh] = useState(false);
    const statusSeverity = (status: boolean): AlertColor => (status ? "success" : "info");

    const onProductStatusLoaded = useCallback((status) => {
        setProductRefresh(false);
        props.handleTransferProductStatus(status);
    }, [props]);

    useEffect(() => {
        if (data && props) {
            let item = data.items.find(i => i.productId === props.productId);
            SetManagedWithInPartition(data.items.length === 0 ? false : item !== undefined);
        }
    }, [data, props]);

    useEffect(() => {
        if (forceRefresh && !loading) {
            refresh();
        }
    }, [refresh, forceRefresh, loading]);

    useEffect(() => {
        if (!loading && !error && data) {
            if (onLoaded) {
                onLoaded(managedWithInPartition ?? false);
            }
        }
    }, [loading, data, error, onLoaded, managedWithInPartition]);

    return (
        <>
            {managedWithInPartition && (
               <ManagedProductStatus     
                productId={props.productId ?? null}
                onLoaded={onProductStatusLoaded}
                forceRefresh={productRefresh}
                formatMessage={() => allocationLocalisations.transferStock.managedProductStatus}
                />
            )}  
            
            {managedWithInPartition === false && (
                <Alert severity={statusSeverity(false)}>{localisations.transferStock.productNotInPartitionStatus}</Alert>
            )}

            
        </>
    );
};

const ProductWithInPartitionStatus = (props: IProductWithInPartitionStatusProps) => {
    if (!props.productId) return null;
    return (
        <InnerProductWithInPartitionStatus
            handleTransferProductStatus ={props.handleTransferProductStatus}
            productId={props.productId}
            partitionId={props.partitionId}
            forceRefresh={props.forceRefresh}
            onLoaded={props.onLoaded}
        ></InnerProductWithInPartitionStatus>
    );
};

export default ProductWithInPartitionStatus;